/** The catalogue keys of the platform's modules, matching `ModuleKeys` on the server. */
export const Modules = {
  StrategicManagement: 'StrategicManagement',
  Accounting: 'Accounting',
  Stock: 'Stock',
  Hr: 'Hr',
  Fleet: 'Fleet',
  Parking: 'Parking',
  Property: 'Property',
  Signing: 'Signing',
  Lending: 'Lending',
  Documents: 'Documents',
  Learning: 'Learning',
  Health: 'Health',
} as const;

export type ModuleKey = (typeof Modules)[keyof typeof Modules];
